import * as React from "react";
import {RouterView, LoadingViewState} from "./RouterView";
import {PagerModel} from "../list/PagerModel";
import {ListUtils} from "../list/ListUtils";
import {ListRequest} from "../../../generated/protocol";
import {extractPathParams, toPathParams} from "../../utils/UrlUtils";

export interface ListViewState<E extends ListRequest> extends LoadingViewState {
    listRequest?: E;
}

interface Params extends ListRequest {
    splat: string;
}

export interface ListViewProps {
    params: Params;
}

/**
 * Creates initial state where both the form and list request have the same values,
 * The form and list request will be populated with path params and takes precedence
 * over the initialForm
 * @param initialForm
 * @param initialListViewState
 */
export function createInitialState<E extends ListRequest>(initialForm: E, initialListViewState: any) {
    console.log("Creating initial state");
    let initial = Object.assign({}, initialForm, initialListViewState.listRequest);
    return Object.assign({}, initialListViewState, {validationMap: {}, form: initial, listRequest: initial});
}


export abstract class ListView<S extends ListViewState<E>, E> extends RouterView<ListViewProps, S> {

    path: string;
    initial?: any;

    protected readonly defaultListRequest: Readonly<ListRequest>;

    constructor(props: ListViewProps, path: string) {
        super(props);
        this.defaultListRequest = {offset: 0, limit: 20, ascending: false};

        let state = Object.assign({}, this.state, {listRequest: this.defaultListRequest});
        this.state = state;
        this.path = path;

        extractPathParams(state.listRequest, props.params);
    }

    componentDidMount() {
        this.initial = this.state.listRequest;
        console.log("Initial state = ", this.initial);
        super.componentDidMount();
    }

    componentDidUpdate(prevProps, prevState) {
        console.log("componentDidUpdate", prevProps, prevState);

        let splat = this.props.params.splat;
        if (!_.isEqual(prevProps.params.splat, splat)) {
            console.log("this.props.params.splat " + splat);
            if (!splat || splat == "") {
                this.setState(({listRequest: this.initial} as any));
            } else {
                let req = {};
                extractPathParams(req, this.props.params);
                this.updateListState(req as any);
            }

        }
    }

    loadContent(): Promise<any> {
        return undefined;
    }

    pagerChanged(pager: PagerModel) {
        console.log("pager changed!", pager);
        var listRequest = ListUtils.toListRequest<E>(this.state.listRequest, pager);
        this.updateListState(listRequest);

    }

    updateListState(listRequest: E) {
        if (_.isEqual(listRequest, this.initial)) {
            this.updatePathParams(this.path, {});
        } else {
            this.updatePathParams(this.path, listRequest);
        }

        if (toPathParams(listRequest) != toPathParams(this.state.listRequest)) {
            setTimeout(() => this.setState(({listRequest: listRequest, form: listRequest} as any)), 0);
        }
    }

    abstract renderContent(): JSX.Element;

}


// WEBPACK FOOTER //
// ./src/app/ui/view/ListView.tsx